<template>
  <section>
    <div class="my--listing-search-repost">
      <div class="my--listing-bulk-repost">
        <router-link to="/bulk-repost" class="btn btn-primary">
          <img src="@/assets/img/icons/repost.png" />
          <span>{{ $t('general.btn.bulkRepost') }}</span>
        </router-link>
      </div>
      <form class="my--listing-search" @submit.prevent="startSearch">
        <input
          id="searchQuery"
          v-model="searchQuery"
          autocomplete="query"
          :placeholder="$t('listing.search')"
          class="basic--input"
        />
        <button class="input--btn" type="submit">
          <img src="@/assets/img/icons/search.svg" alt="Cari" />
        </button>
        <button class="delete--btn" type="button" @click="clearSearchQuery" v-if="searchQuery">
          <span class="ion-close"></span>
        </button>
      </form>
    </div>
    <div class="my--order-header my--listing-header">
      <div class="dashboard--search-container">
        <div class="dropdown--wrapper">
          <v-select
            :value="sortBy"
            @input="inputSortByHandler"
            :hint="`${$t('general.filter.sort')} ${$t(`general.filter.${sortBy.name}`)}`"
            :items="sortByList"
            :item-text="sortByLabel"
            item-value="name"
            class="basic--dropdown"
            return-object
            single-line
            hide-details
            no
          />
        </div>
      </div>
      <div class="my--listing-add">
        <button type="button" class="btn btn-primary filter--button" @click="openFilter">
          <img src="@/assets/img/icons/filter-white.svg" alt="Filter" />
          {{ filterButtonText }}
        </button>
        <button type="button" class="btn btn-primary" @click="openAddListing">
          {{ `+ ${$t('listing.add')}` }}
        </button>
      </div>
    </div>
    <listing-filter-modal />
  </section>
</template>

<script>
import debounce from 'lodash/debounce';
import { mapState } from 'vuex';
import HelperMixin from '@/mixins/helpers';
import ListingFilterModal from '@/components/listing/modals/listing-filter-modal.vue';
import { chooseListingDraft } from '@/services/listingDraftRecovery';
import { acquireListingDraftLock, releaseListingDraftLock } from '@/services/listingDraftLock';

export default {
  name: 'listings-header',
  mixins: [HelperMixin],
  components: {
    ListingFilterModal,
  },
  computed: {
    ...mapState({
      sortByList: (state) => state.listing.sortByList,
      sortBy: (state) => state.listing.sortBy,
      type: (state) => state.listing.type,
      selectedPropertyTypes: (state) => state.listing.selectedPropertyTypes,
      user: (state) => state.global.user,
    }),
    activeFilterCount() {
      let count = this.type ? 1 : 0;
      count += this.selectedPropertyTypes ? this.selectedPropertyTypes.length : 0;
      return count;
    },
    filterButtonText() {
      return this.activeFilterCount
        ? `${this.$t('general.filterText')} (${this.activeFilterCount})`
        : this.$t('general.filterText');
    },
    searchQuery: {
      get() {
        return this.$store.state.listing.searchQuery;
      },
      set(val) {
        val = this.cleanInput(val);
        this.$store.commit('listing/SET_SEARCH_QUERY', val);
        this.debounceSearch();
      },
    },
  },
  methods: {
    sortByLabel(value) {
      return this.$i18n.t(`general.filter.${value.name}`);
    },
    async inputSortByHandler(value) {
      this.$store.commit('listing/SET_SORT_BY', value);
      await this.$store.dispatch('listing/getAllListings', {});
    },
    openFilter() {
      this.$modal.show('listing-filter-modal');
    },
    async openAddListing() {
      if (!this.user || !this.user.uuid) return;
      const lockAcquired = await acquireListingDraftLock(this.user.uuid);
      if (!lockAcquired) {
        await this.$swal(
          'Draft Sedang Dibuka',
          'Tutup tab Add Listing lain sebelum melanjutkan.',
          'warning',
        );
        return;
      }
      try {
        const result = await chooseListingDraft(this, this.user.uuid);
        if (result.choice === 'continue') {
          this.$router.push({ path: '/listing/add', query: { draft: result.draft.draftId } });
        } else if (result.choice === 'close') {
          releaseListingDraftLock();
          return;
        } else {
          this.$router.push({ path: '/listing/add', query: { fresh: '1' } });
        }
      } catch (_) {
        await this.$swal(
          'Draft Lokal Tidak Tersedia',
          'Form tetap dapat digunakan tanpa pemulihan lokal.',
          'warning',
        );
        this.$router.push({ path: '/listing/add', query: { fresh: '1' } });
      }
    },
    async startSearch() {
      this.$store.commit('listing/SET_PAGE', 1);
      await this.$store.dispatch('listing/getAllListings', {});
    },
    debounceSearch: debounce(function () {
      this.startSearch();
    }, 500),
    clearSearchQuery() {
      this.searchQuery = null;
    },
  },
};
</script>

<style lang="scss">
@import '../../assets/scss/utils/variables';
.my--listing-search-repost {
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media #{$phones} {
    display: initial;
  }
  .my--listing-bulk-repost {
    @media #{$phones} {
      width: 100%;
      margin-bottom: 6px;
      display: flex;
      justify-content: right;
    }
    img {
      width: 20px;
      height: 20px;
      object-fit: contain;
      margin-right: 4px;
    }
  }
}
.my--listing-search {
  display: flex;
  position: relative;
  justify-content: flex-end;
  margin-bottom: 6px;
  .basic--input {
    padding: 11px 40px 11px 16px;
    width: 400px;
    max-width: 400px;
  }
  .delete--btn {
    position: absolute;
    top: 12px;
    right: 72px;
    @media #{$phones} {
      top: 14px;
    }
  }
  .input--btn {
    width: 48px;
    height: 48px;
    background-color: $color-beliruma-1;
    border-radius: 16px;
    margin-left: 8px;

    @media #{$phones} {
      width: 48px;
      height: 48px;
    }

    img {
      width: 48px;
      height: 48px;
      object-fit: contain;
      padding: 12px;

      @media #{$phones} {
        padding: 12px;
      }
    }
  }
}
.my--listing-header {
  width: fit-content;
  float: right;
  position: relative;
  z-index: 2;
  justify-content: flex-end;
  margin-bottom: -60px;

  @media #{$phones, $tablets} {
    width: 100%;
    float: initial;
    margin-bottom: -16px;
  }
  @media #{$phones} {
    justify-content: space-between;
  }

  .dashboard--search-container {
    flex-grow: 0;

    @media #{$phones} {
      width: calc(50% - 0px);
    }

    .dropdown--wrapper {
      max-width: 260px;
      @media #{$phones} {
        width: calc(100%);
      }
    }

    .v-text-field > .v-input__control > .v-input__slot::before {
      border: none;
    }

    .v-text-field > .v-input__control > .v-input__slot::after {
      border: none;
    }
  }

  .my--listing-add {
    display: flex;
    gap: 8px;
    @media #{$phones} {
      width: calc(50% - 0px);
      flex-direction: column;
    }

    .filter--button,
    .btn-primary {
      white-space: nowrap;
    }

    .filter--button {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 6px;

      img {
        width: 16px;
        height: 16px;
        filter: brightness(0) saturate(100%) invert(100%);
      }
    }
  }
}
</style>
